import React from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { Gender } from "../../store/models/Gender";
import { RegistrationDto } from "../../store/models/RegistrationDto";
import { nameof } from "../app/Utils";
import { PaliFinalFormCheckbox } from "../pali/PaliFinalFormCheckbox";
import { PaliFinalFormInput } from "../pali/PaliFinalFormInput";
import { PaliFinalFormSelect } from "../pali/PaliFinalFormSelect";
import { getLabelText } from "./RegistrationForm";
import { RegistrationFormThunkProps } from "./RegistrationFormContainer";
import { isFieldNeeded, isVisibleField } from "./Validation";
import { PaliRadioButton } from "../pali/PaliRadioButton";
import { customerTypeOptions } from "../customer/CustomerType";

let genderOptions = [
  { value: "", label: "Bitte auswählen" },
  { value: Gender.MALE, label: "männlich" },
  { value: Gender.FEMALE, label: "weiblich" },
  { value: Gender.DIVERSE, label: "divers" },
];

export default class PersonalData extends React.Component<RegistrationFormThunkProps> {
  render() {
    const { registration, branchStores, registrationDisplayConfig, registrationFieldConfig } = this.props;
    return (
      <Card id="personal" className="mb-5">
        <CardBody>
          <CardTitle>Persönliche Daten</CardTitle>
          <Row>
            <Col md={6}>
              {isFieldNeeded(nameof<RegistrationDto>("gender"), registrationFieldConfig) && (
                <PaliFinalFormSelect
                  name={nameof<RegistrationDto>("gender")}
                  label={getLabelText("Geschlecht", nameof<RegistrationDto>("gender"), registrationFieldConfig)}
                  options={genderOptions}
                />
              )}
            </Col>
            <Col md={6}>
              {isFieldNeeded(nameof<RegistrationDto>("title"), registrationFieldConfig) && (
                <PaliFinalFormInput
                  type="text"
                  name={nameof<RegistrationDto>("title")}
                  label={getLabelText("Titel", nameof<RegistrationDto>("title"), registrationFieldConfig)}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              {isFieldNeeded(nameof<RegistrationDto>("firstName"), registrationFieldConfig) && (
                <PaliFinalFormInput
                  type="text"
                  name={nameof<RegistrationDto>("firstName")}
                  label={getLabelText("Vorname", nameof<RegistrationDto>("firstName"), registrationFieldConfig)}
                  readOnly={Boolean(registration.firstName)}
                />
              )}
            </Col>
            <Col md={6}>
              {isFieldNeeded(nameof<RegistrationDto>("lastName"), registrationFieldConfig) && (
                <PaliFinalFormInput
                  type="text"
                  name={nameof<RegistrationDto>("lastName")}
                  label={getLabelText("Nachname", nameof<RegistrationDto>("lastName"), registrationFieldConfig)}
                  readOnly={Boolean(registration.lastName)}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              {isFieldNeeded(nameof<RegistrationDto>("companyName"), registrationFieldConfig) && (
                <PaliFinalFormInput
                  type="text"
                  name={nameof<RegistrationDto>("companyName")}
                  label={getLabelText("Firmenname", nameof<RegistrationDto>("companyName"), registrationFieldConfig)}
                />
              )}
            </Col>
            <Col md={6}>
              {isFieldNeeded(nameof<RegistrationDto>("vatId"), registrationFieldConfig) && (
                <PaliFinalFormInput
                  type="text"
                  name={nameof<RegistrationDto>("vatId")}
                  label={getLabelText("USt-ID", nameof<RegistrationDto>("vatId"), registrationFieldConfig)}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              {isFieldNeeded(nameof<RegistrationDto>("customerType"), registrationFieldConfig) && (
                <PaliRadioButton name={nameof<RegistrationDto>("customerType")} options={customerTypeOptions} row />
              )}
            </Col>
          </Row>

          <Row>
            {Boolean(branchStores?.length) && (
              <Col md={6}>
                {isFieldNeeded(nameof<RegistrationDto>("masterUnitNumber"), registrationFieldConfig) && (
                  <PaliFinalFormSelect
                    name={nameof<RegistrationDto>("masterUnitNumber")}
                    label={getLabelText(
                      "Meine Filiale",
                      nameof<RegistrationDto>("masterUnitNumber"),
                      registrationFieldConfig
                    )}
                    options={[{ label: "bitte wählen...", value: "" }].concat(
                      branchStores.map((branchStore) => ({
                        label: branchStore.unitName,
                        value: branchStore.unitNumber,
                      }))
                    )}
                  />
                )}
              </Col>
            )}
            <Col md={6}>
              {isFieldNeeded(nameof<RegistrationDto>("externalCustomerId"), registrationFieldConfig) && (
                <PaliFinalFormInput
                  type="text"
                  name={nameof<RegistrationDto>("externalCustomerId")}
                  label={getLabelText(
                    "Kundennummer",
                    nameof<RegistrationDto>("externalCustomerId"),
                    registrationFieldConfig
                  )}
                />
              )}
            </Col>
          </Row>

          <Row>
            <Col>
              {isVisibleField(nameof<RegistrationDto>("emailCorrespondenceAllowed"), registrationDisplayConfig) && (
                <PaliFinalFormCheckbox
                  name={nameof<RegistrationDto>("emailCorrespondenceAllowed")}
                  label="Ja, ich möchte den regelmäßigen Newsletter erhalten. Die Einwilligung zum Erhalt des Newsletters können Sie jederzeit mit Wirkung für die Zukunft widerrufen, beispielsweise durch das Anklicken des Abmeldelinks am Ende jedes Newsletters."
                />
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
}
